import { useState } from 'react';
import { TicketModal } from './TicketModal';
import { ChatModal } from './ChatModal';
import { TicketListModal } from './TicketListModal';

export default function SupportWidget() {
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [showTicketList, setShowTicketList] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleOpenTicket = () => {
    setShowMenu(false);
    setShowTicketModal(true);
  };

  const handleOpenChat = () => {
    setShowMenu(false);
    setShowChatModal(true);
  };

  const handleViewTickets = () => {
    setShowMenu(false);
    setShowTicketList(true);
  };

  return (
    <>
      <div className="relative">
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="w-full flex items-center justify-center space-x-3 px-4 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors cursor-pointer shadow-lg"
          title="Suporte"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-customer-service-2-line text-xl"></i>
          </div>
          <span className="text-sm font-bold whitespace-nowrap">Suporte</span>
        </button>

        {showMenu && (
          <>
            <div 
              className="fixed inset-0 z-40"
              onClick={() => setShowMenu(false)}
            ></div>
            <div className="absolute bottom-full left-0 right-0 mb-2 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden z-50">
              <button
                onClick={handleOpenChat}
                className="w-full flex items-center space-x-3 px-4 py-3 hover:bg-blue-50 transition-colors cursor-pointer text-left border-b border-gray-100"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg">
                  <i className="ri-chat-3-line text-green-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900 whitespace-nowrap">Chat Online</div>
                  <div className="text-xs text-gray-500 whitespace-nowrap">Fale conosco agora</div>
                </div>
              </button>

              <button
                onClick={handleOpenTicket}
                className="w-full flex items-center space-x-3 px-4 py-3 hover:bg-blue-50 transition-colors cursor-pointer text-left border-b border-gray-100"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-blue-100 rounded-lg">
                  <i className="ri-ticket-line text-blue-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900 whitespace-nowrap">Abrir Chamado</div>
                  <div className="text-xs text-gray-500 whitespace-nowrap">Registre sua solicitação</div>
                </div>
              </button>

              <button
                onClick={handleViewTickets}
                className="w-full flex items-center space-x-3 px-4 py-3 hover:bg-blue-50 transition-colors cursor-pointer text-left"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-purple-100 rounded-lg">
                  <i className="ri-file-list-3-line text-purple-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900 whitespace-nowrap">Meus Chamados</div>
                  <div className="text-xs text-gray-500 whitespace-nowrap">Acompanhe suas solicitações</div>
                </div>
              </button>
            </div>
          </>
        )}
      </div>

      {showTicketModal && (
        <TicketModal isOpen={showTicketModal} onClose={() => setShowTicketModal(false)} />
      )}

      {showChatModal && (
        <ChatModal isOpen={showChatModal} onClose={() => setShowChatModal(false)} />
      )}

      {showTicketList && (
        <TicketListModal isOpen={showTicketList} onClose={() => setShowTicketList(false)} />
      )}
    </>
  );
}
